// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"95962033","276":"d8776d66","386":"6c4ca8e6","409":"245be947","453":"926f0775","583":"fcd3ae21","736":"75264b98","786":"8897fc4e","817":"ae00a64f","987":"f9f41d31"}[chunkId] + ".chunk.js";
};